/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { css } from "@emotion/css";
import { ActionButton } from "@octopusdeploy/design-system-components";
import { TextWithLabel as Text } from "@octopusdeploy/design-system-octopus-components";
import type { FormFieldProps } from "@octopusdeploy/design-system-octopus-components";
import { borderRadius, colorScales, themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
import Dialog from "~/components/Dialog/Dialog";
import { DialogLayout } from "~/components/DialogLayout/DialogLayout";
interface ColorPickerProps extends FormFieldProps<string> {
    defaultColor?: string;
    id?: string;
    disabled?: boolean;
    label?: string | JSX.Element;
    error?: string;
    warning?: string;
    validate?(value: string): string;
    onValidate?(value: string): void;
}
export function ColorPicker({ id, label, validate, error: propError, onChange, onValidate, defaultColor, value, warning }: ColorPickerProps) {
    const [pickerOpen, setPickerOpen] = React.useState(false);
    const [error, setError] = React.useState<string | null>(null);
    const err = error || propError;
    const errorText = err || warning;
    const val = value ? value : "";
    const colorSet1 = [colorScales.red[300], colorScales.orange[300], colorScales.green[300], colorScales.blue[300], colorScales.navy[300], colorScales.purple[300], colorScales.grey[300]];
    const colorSet2 = [colorScales.red[200], colorScales.orange[200], colorScales.green[200], colorScales.blue[200], colorScales.navy[200], colorScales.purple[200], colorScales.grey[200]];
    const cancel = <ActionButton key="CancelButton" label="Cancel" onClick={() => setPickerOpen(false)}/>;
    const handleChange = (value: string) => {
        if (validate) {
            const result = validate(value);
            setError(result);
            if (onValidate) {
                onValidate(result);
            }
        }
        onChange!(value);
    };
    const renderPaletteSwatch = (color: string) => {
        return (<button key={color} className={colorPickerStyles.colorPickItem} style={{ backgroundColor: color }} title={color} onClick={(e) => {
                e.preventDefault();
                handleChange(color);
                setPickerOpen(false);
            }}/>);
    };
    return (<div className={colorPickerStyles.container}>
            <Text id={id} placeholder={defaultColor} value={val} onChange={handleChange} error={errorText} label={label}/>
            <button className={colorPickerStyles.colorSwatch} style={{ backgroundColor: val || defaultColor }} onClick={(e) => {
            e.preventDefault();
            setPickerOpen(true);
        }}/>
            <Dialog open={pickerOpen}>
                <DialogLayout actions={[cancel]} title="Standard Palette" closeDialog={() => setPickerOpen(false)}>
                    <div>
                        <div className={colorPickerStyles.colorAllOptions}>{colorSet1.map(renderPaletteSwatch)}</div>
                        <div className={colorPickerStyles.colorAllOptions}>{colorSet2.map(renderPaletteSwatch)}</div>
                    </div>
                </DialogLayout>
            </Dialog>
        </div>);
}
const colorPickerStyles = {
    container: css({
        display: "flex",
        width: "7rem",
        position: "relative",
        flex: "0 0 7rem",
    }),
    colorSwatch: css({
        width: "1.5rem",
        height: "1.5rem",
        borderRadius: borderRadius.small,
        border: `1px solid ${themeTokens.color.border.tertiary}`,
        position: "absolute",
        bottom: "1.5rem",
        right: "0.5rem",
        cursor: "pointer",
    }),
    colorPickItem: css({
        width: "2.5rem",
        height: "2.5rem",
        cursor: "pointer",
        transition: "background-color 0.1s linear",
        border: 0,
    }),
    colorAllOptions: css({
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
    }),
};
